import MojitoCore from 'mojito/core';
import InProgressBonusesImpl from './in-progress-bonuses.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component responsible for presenting the view of bonuses in progress.
 *
 * @name View
 * @class InProgressBonuses
 * @memberof Mojito.Modules.InProgressBonuses
 */

export default UIView('InProgressBonuses', InProgressBonusesImpl);
